import fetch from './api'

// 我的批改任务
const GETMYCORRECTTASK = params => {
    return fetch({
        url: '/api/admin/zjjk/getMyCorrectList',
        method: 'get',
        params: params
    })
}
// 释放任务
const CORRECTRELEASE = params => {
  return fetch({
      url: '/api/admin/zjjk/correctRelease',
      method: 'post',
      data: params
  })
}
export default {
    GETMYCORRECTTASK,
    CORRECTRELEASE
}



// WEBPACK FOOTER //
// ./src/api/interface-zhaojing.js